import type { FC } from 'react';
import CreateGuide from '@/app/assets/imgs/create_guide.svg';

export const Empty: FC<{ emptyText: string }> = ({ emptyText }) => {
  return (
    <div className="flex h-full min-h-[400px] w-full flex-col items-center justify-center text-sm text-system-white64">
      <img
        src={CreateGuide.src}
        alt="create_guide"
        width={400}
        height={277}
        className="mb-8 h-auto w-[400px] opacity-60 sm:hidden lg:mb-6 lg:w-[320px]"
      />
      <div className="mb-10 text-center">{emptyText}</div>
    </div>
  );
};
